module.exports = __webpack_public_path__ + "img/no-data-table.d28f5bf7.svg";